module.exports = __webpack_public_path__ + "static/img/04-configure-external-tool-select-blade.7b59b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lti-assignment-guide/04-configure-external-tool-select-blade.png
// module id = 84TV
// module chunks = 1